import { useContext } from 'react';

import { ExamEventDetailsContext } from './exam-event-details-provider';

function useExamEventDetails() {
  const context = useContext(ExamEventDetailsContext);

  if (!context) {
    throw new Error('useExamEventDetails must be used within a ExamEventDetailsProvider');
  }

  return context;
}

export { useExamEventDetails };
